
export default class GHLine {
  constructor (a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
  }

  getIntersectionPoint (l) {
    let d = this.a * l.b - l.a * this.b;
    if (d === 0.0) {
      return null;
    }

    const x = (this.b * l.c - l.b * this.c) / d;
    const y = (l.a * this.c - this.a * l.c) / d;
    return new THREE.Vector2(x, y);
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/math/GHLine.js